/**
 * WordPress dependencies
 */
import { forwardRef, useRef } from '@wordpress/element';
import { useMergeRefs } from '@wordpress/compose';

/**
 * Internal dependencies
 */
import { ControlWithError } from '../control-with-error';
import TextareaControl from '../../textarea-control';
import { jsx as _jsx } from "react/jsx-runtime";
const UnforwardedValidatedTextareaControl = ({
  required,
  customValidity,
  markWhenOptional,
  ...restProps
}, forwardedRef) => {
  const validityTargetRef = useRef(null);
  const mergedRefs = useMergeRefs([forwardedRef, validityTargetRef]);
  return /*#__PURE__*/_jsx(ControlWithError, {
    required: required,
    markWhenOptional: markWhenOptional,
    customValidity: customValidity,
    getValidityTarget: () => validityTargetRef.current,
    children: /*#__PURE__*/_jsx(TextareaControl, {
      ref: mergedRefs,
      ...restProps
    })
  });
};
export const ValidatedTextareaControl = forwardRef(UnforwardedValidatedTextareaControl);
ValidatedTextareaControl.displayName = 'ValidatedTextareaControl';